import React from 'react'
import ReactTooltip from 'react-tooltip'
import { BigNumber } from 'ethers'
import { formatUnits } from 'ethers/lib/utils'
import classNames from 'classnames'
import { renderAmount } from '~/lib/helpers'

import styles from './AboutLockInfo.pcss'

export interface AboutLockInfoProps {
	digits?: number
	hint?: string
	invertPlaceholder?: boolean
	label: string
	percent?: boolean
	postfix?: string
	value?: BigNumber | number | string
	valueStyle?: string
	renderContent?: (content: React.ReactNode) => React.ReactNode
}

export function AboutLockInfo({
	digits = 6,
	hint,
	invertPlaceholder = false,
	label,
	percent = false,
	postfix,
	value,
	valueStyle,
	renderContent,
}: AboutLockInfoProps) {
	let content: React.ReactNode

	if (value === undefined) {
		let placeholder = invertPlaceholder ? '\\' : '/'

		content = (
			<div className={styles.placeholder}>
				<div>{placeholder}</div>
				<div>{placeholder}</div>
				<div>{placeholder}</div>
			</div>
		)
	} else {
		if (BigNumber.isBigNumber(value)) {
			content = renderAmount(formatUnits(value), digits)
		} else if (typeof value === 'number') {
			content = renderAmount(value, digits)
		} else {
			content = value
		}

		if (percent) {
			content += '%'
		}

		if (postfix !== undefined) {
			content = `${content} ${postfix}`
		}

		if (renderContent) {
			content = renderContent(content)
		}
	}

	return (
		<div className={styles.container}>
			<div className={styles.label}>
				<span className={styles.labelText}>{label}</span>
				{!!hint && (
					<span className={styles.question} data-tip data-for={hint}>
						{'{?}'}
					</span>
				)}
			</div>

			<div className={classNames(styles.value, valueStyle)}>
				{content}
			</div>

			{!!hint && (
				<ReactTooltip
					id={hint}
					place="right"
					effect="float"
					className={styles.tooltip}
					arrowColor="transparent"
					offset={{
						bottom: 20,
					}}
				>
					<div className={styles.hint}>{hint}</div>
				</ReactTooltip>
			)}
		</div>
	)
}
